"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CostInvoiceDetails;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_bootstrap_1 = require("react-bootstrap");
const CostInvoicesController_1 = require("./CostInvoicesController");
const CostInvoicesBadges_1 = require("./CostInvoicesBadges");
const Tools_1 = __importDefault(require("../../React/Tools/Tools"));
const ToolsDate_1 = __importDefault(require("../../React/Tools/ToolsDate"));
const CommonComponents_1 = require("../../View/Resultsets/CommonComponents");
const qrcode_react_1 = require("qrcode.react");
function CostInvoiceDetails() {
    const { id } = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [invoice, setInvoice] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [saving, setSaving] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const [success, setSuccess] = (0, react_1.useState)(null);
    const [qrData, setQrData] = (0, react_1.useState)(null);
    const [qrLoading, setQrLoading] = (0, react_1.useState)(false);
    const [qrError, setQrError] = (0, react_1.useState)(null);
    const [whiteListChecking, setWhiteListChecking] = (0, react_1.useState)(false);
    const [whiteListError, setWhiteListError] = (0, react_1.useState)(null);
    // Edytowalne pola faktury
    const [notes, setNotes] = (0, react_1.useState)("");
    const [paymentStatus, setPaymentStatus] = (0, react_1.useState)(CostInvoicesController_1.PaymentStatuses.UNPAID);
    const [paidAmount, setPaidAmount] = (0, react_1.useState)(0);
    const updateListCaches = (0, react_1.useCallback)((updatedInvoice) => {
        if (!updatedInvoice?.id)
            return;
        const updateById = (items, nextItem) => {
            if (!Array.isArray(items))
                return items;
            let found = false;
            const updated = items.map((item) => {
                if (item?.id === nextItem.id) {
                    found = true;
                    return { ...item, ...nextItem };
                }
                return item;
            });
            return found ? updated : items;
        };
        try {
            const repoRaw = sessionStorage.getItem("costInvoices");
            if (repoRaw) {
                const repoParsed = JSON.parse(repoRaw);
                const updatedItems = updateById(repoParsed?.items || [], updatedInvoice);
                sessionStorage.setItem("costInvoices", JSON.stringify({ ...repoParsed, items: updatedItems }));
            }
        }
        catch (error) {
            console.warn("[CostInvoiceDetails] Nie udało się zaktualizować cache repozytorium", error);
        }
        try {
            const snapshotKey = "filtersableTableSnapshot_costInvoices";
            const snapshotRaw = sessionStorage.getItem(snapshotKey);
            if (snapshotRaw) {
                const snapshotParsed = JSON.parse(snapshotRaw);
                const updatedStoredObjects = updateById(snapshotParsed?.storedObjects || [], updatedInvoice);
                sessionStorage.setItem(snapshotKey, JSON.stringify({ ...snapshotParsed, storedObjects: updatedStoredObjects }));
            }
        }
        catch (error) {
            console.warn("[CostInvoiceDetails] Nie udało się zaktualizować snapshotu listy", error);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (!id)
            return;
        loadData();
    }, [id]);
    const loadData = (0, react_1.useCallback)(async () => {
        if (!id)
            return;
        setLoading(true);
        setError(null);
        try {
            const invoiceData = await (0, CostInvoicesController_1.fetchCostInvoiceDetails)(Number(id));
            setInvoice(invoiceData);
            // Ustaw wartości edytowalnych pól
            setNotes(invoiceData.notes || "");
            setPaymentStatus(invoiceData.paymentStatus ?? CostInvoicesController_1.PaymentStatuses.UNPAID);
            setPaidAmount(invoiceData.paidAmount ?? 0);
            document.title = `Faktura ${invoiceData.invoiceNumber} | ${invoiceData.supplierName}`;
        }
        catch (err) {
            setError(err instanceof Error ? err.message : "Błąd ładowania danych");
        }
        finally {
            setLoading(false);
        }
    }, [id]);
    (0, react_1.useEffect)(() => {
        if (!invoice?.id)
            return;
        setQrLoading(true);
        setQrError(null);
        setQrData(null);
        (0, CostInvoicesController_1.fetchCostInvoiceQr)(invoice.id)
            .then((data) => {
            setQrData(data);
        })
            .catch((err) => {
            if (err instanceof CostInvoicesController_1.CostInvoiceApiError) {
                setQrError(err.message);
                return;
            }
            setQrError(err instanceof Error ? err.message : "Błąd pobierania danych QR");
        })
            .finally(() => {
            setQrLoading(false);
        });
    }, [invoice?.id]);
    const handleSave = async () => {
        if (!invoice)
            return;
        if (paymentStatus === CostInvoicesController_1.PaymentStatuses.PARTIALLY_PAID && paidAmount <= 0) {
            setError("Dla statusu 'Częściowo zapłacona' kwota zapłacona musi być większa od 0.");
            return;
        }
        setSaving(true);
        setError(null);
        setSuccess(null);
        try {
            const updatedInvoice = await (0, CostInvoicesController_1.updateCostInvoice)(invoice.id, {
                notes: notes || null,
                paymentStatus,
                paidAmount,
            });
            updateListCaches(updatedInvoice);
            setInvoice((prev) => (prev ? { ...prev, ...updatedInvoice } : updatedInvoice));
            setPaymentStatus(updatedInvoice.paymentStatus ?? CostInvoicesController_1.PaymentStatuses.UNPAID);
            setPaidAmount(updatedInvoice.paidAmount ?? 0);
            setSuccess("Zmiany zostały zapisane");
            // Odśwież dane
            await loadData();
        }
        catch (err) {
            setError(err instanceof Error ? err.message : "Błąd zapisywania");
        }
        finally {
            setSaving(false);
        }
    };
    const copyQrLink = async (qrLink) => {
        try {
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(qrLink);
            }
            else {
                const textarea = document.createElement("textarea");
                textarea.value = qrLink;
                textarea.setAttribute("readonly", "true");
                textarea.style.position = "absolute";
                textarea.style.left = "-9999px";
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand("copy");
                document.body.removeChild(textarea);
            }
            setSuccess("Link QR został skopiowany do schowka.");
        }
        catch (err) {
            setError(err instanceof Error ? err.message : "Nie udało się skopiować linku QR");
        }
    };
    /**
     * NIP-K2 — ręczna (re-)weryfikacja Białej Listy VAT (KAS wl-api). Nadpisuje
     * poprzedni wynik i odświeża badge. Weryfikacja jest tylko ostrzegawcza
     * (patrz alert NIEZGODNOŚĆ niżej).
     */
    const handleCheckWhiteList = async () => {
        if (!invoice?.id)
            return;
        setWhiteListChecking(true);
        setWhiteListError(null);
        try {
            const updated = await (0, CostInvoicesController_1.checkWhiteList)(invoice.id);
            updateListCaches(updated);
            setInvoice((prev) => (prev ? { ...prev, ...updated } : updated));
        }
        catch (err) {
            setWhiteListError(err instanceof CostInvoicesController_1.CostInvoiceApiError
                ? err.message
                : err instanceof Error
                    ? err.message
                    : "Błąd weryfikacji Białej Listy");
        }
        finally {
            setWhiteListChecking(false);
        }
    };
    if (loading) {
        return (react_1.default.createElement("div", { className: "text-center m-5" },
            react_1.default.createElement(CommonComponents_1.SpinnerBootstrap, null),
            react_1.default.createElement("div", { className: "mt-3" }, "\u0141adowanie danych faktury...")));
    }
    if (!invoice) {
        return (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", className: "m-3" }, "Nie znaleziono faktury"));
    }
    const supplierBankAccount = invoice.supplierBankAccount?.trim();
    const canMarkPartiallyPaid = invoice.grossAmount > 0;
    const items = invoice._items || [];
    return (react_1.default.createElement(react_bootstrap_1.Container, { fluid: true, className: "py-3" },
        error && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", onClose: () => setError(null), dismissible: true }, error)),
        success && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success", onClose: () => setSuccess(null), dismissible: true }, success)),
        react_1.default.createElement(react_bootstrap_1.Card, { className: "mb-3" },
            react_1.default.createElement(react_bootstrap_1.Card.Header, null,
                react_1.default.createElement(react_bootstrap_1.Row, { className: "align-items-center" },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement("h4", { className: "mb-0" },
                            "Faktura ",
                            invoice.invoiceNumber,
                            react_1.default.createElement(CostInvoicesBadges_1.InvoiceTypeBadge, { invoiceType: invoice.invoiceType }),
                            " ",
                            react_1.default.createElement(CostInvoicesBadges_1.WhiteListStatusBadge, { status: invoice.whiteListStatus, checkedAt: invoice.whiteListCheckedAt, requestId: invoice.whiteListRequestId }))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: "auto" },
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: () => navigate("/costInvoices") }, "\u2190 Powr\u00F3t do listy")))),
            react_1.default.createElement(react_bootstrap_1.Card.Body, null,
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.Col, { md: 6 },
                        react_1.default.createElement("h6", null, "Dostawca"),
                        react_1.default.createElement("p", { className: "mb-1" },
                            react_1.default.createElement("strong", null, invoice.supplierName)),
                        react_1.default.createElement("p", { className: "mb-1 text-muted" },
                            "NIP: ",
                            invoice.supplierNip),
                        invoice.supplierAddress && (react_1.default.createElement("p", { className: "mb-1 text-muted small" }, invoice.supplierAddress)),
                        react_1.default.createElement("p", { className: "mb-0 small" },
                            react_1.default.createElement("span", { className: "text-muted" }, "Konto: "),
                            supplierBankAccount ? (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("code", null, supplierBankAccount),
                                react_1.default.createElement(react_bootstrap_1.Button, { variant: "link", size: "sm", className: "py-0 px-1", title: "Kopiuj numer rachunku", onClick: () => navigator.clipboard.writeText(supplierBankAccount) }, "\u2398"))) : (react_1.default.createElement("span", { className: "text-muted" }, "brak")))),
                    react_1.default.createElement(react_bootstrap_1.Col, { md: 3 },
                        react_1.default.createElement("h6", null, "Daty"),
                        react_1.default.createElement("p", { className: "mb-1" },
                            react_1.default.createElement("small", { className: "text-muted" }, "Wystawienia:"),
                            " ",
                            ToolsDate_1.default.dateYMDtoDMY(invoice.issueDate)),
                        invoice.saleDate && (react_1.default.createElement("p", { className: "mb-1" },
                            react_1.default.createElement("small", { className: "text-muted" }, "Sprzeda\u017Cy:"),
                            " ",
                            ToolsDate_1.default.dateYMDtoDMY(invoice.saleDate))),
                        invoice.dueDate && (react_1.default.createElement("p", { className: "mb-1" },
                            react_1.default.createElement("small", { className: "text-muted" }, "P\u0142atno\u015Bci:"),
                            " ",
                            ToolsDate_1.default.dateYMDtoDMY(invoice.dueDate))),
                        invoice.paymentDate && (react_1.default.createElement("p", { className: "mb-0" },
                            react_1.default.createElement("small", { className: "text-muted" }, "Zap\u0142acono:"),
                            " ",
                            react_1.default.createElement("strong", { className: "text-success" }, ToolsDate_1.default.dateYMDtoDMY(invoice.paymentDate))))),
                    react_1.default.createElement(react_bootstrap_1.Col, { md: 3 },
                        react_1.default.createElement("h6", null, "Warto\u015Bci"),
                        react_1.default.createElement("p", { className: "mb-1" },
                            react_1.default.createElement("small", { className: "text-muted" }, "Netto:"),
                            " ",
                            react_1.default.createElement("strong", null,
                                Tools_1.default.formatNumber(invoice.netAmount),
                                " ",
                                invoice.currency)),
                        react_1.default.createElement("p", { className: "mb-1" },
                            react_1.default.createElement("small", { className: "text-muted" }, "VAT:"),
                            " ",
                            Tools_1.default.formatNumber(invoice.vatAmount),
                            " ",
                            invoice.currency),
                        react_1.default.createElement("p", { className: "mb-0" },
                            react_1.default.createElement("small", { className: "text-muted" }, "Brutto:"),
                            " ",
                            react_1.default.createElement("strong", null,
                                Tools_1.default.formatNumber(invoice.grossAmount),
                                " ",
                                invoice.currency)))),
                react_1.default.createElement(react_bootstrap_1.Row, { className: "mt-3" },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement("small", { className: "text-muted" }, "Nr KSeF: "),
                        react_1.default.createElement("code", { className: "small" }, invoice.ksefNumber))))),
        react_1.default.createElement(react_bootstrap_1.Card, { className: "mb-3" },
            react_1.default.createElement(react_bootstrap_1.Card.Header, null,
                react_1.default.createElement("h5", { className: "mb-0" }, "KSeF - kod QR")),
            react_1.default.createElement(react_bootstrap_1.Card.Body, null,
                qrLoading && (react_1.default.createElement("div", { className: "mb-3" },
                    react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", className: "me-2" }),
                    "\u0141adowanie danych QR...")),
                qrError && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info", className: "mb-0" }, qrError)),
                !qrLoading && !qrError && qrData && (react_1.default.createElement(react_bootstrap_1.Row, { className: "align-items-center g-3" },
                    react_1.default.createElement(react_bootstrap_1.Col, { md: 4, className: "text-center" },
                        react_1.default.createElement("div", { className: "d-inline-flex p-2 bg-white border rounded-3 shadow-sm" },
                            react_1.default.createElement(qrcode_react_1.QRCodeSVG, { value: qrData.qrVerificationUrl, size: 176, level: "M", includeMargin: true })),
                        react_1.default.createElement("div", { className: "mt-2 small text-muted" }, "Kod QR dla faktury kosztowej"),
                        react_1.default.createElement("div", { className: "fw-bold" }, qrData.qrLabel)),
                    react_1.default.createElement(react_bootstrap_1.Col, { md: 8 },
                        react_1.default.createElement("div", { className: "fw-semibold mb-2" }, "Link weryfikacyjny KSeF"),
                        react_1.default.createElement("div", { className: "small text-break mb-3" },
                            react_1.default.createElement("code", null, qrData.qrVerificationUrl)),
                        react_1.default.createElement("div", { className: "d-flex gap-2 flex-wrap" },
                            react_1.default.createElement(react_bootstrap_1.Button, { as: "a", href: qrData.qrVerificationUrl, target: "_blank", rel: "noopener noreferrer", variant: "outline-primary", size: "sm" }, "Otw\u00F3rz link"),
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: () => copyQrLink(qrData.qrVerificationUrl) }, "Kopiuj link"))))),
                !qrLoading && !qrError && !qrData && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info", className: "mb-0" }, "Brak danych do wygenerowania kodu QR.")))),
        react_1.default.createElement(react_bootstrap_1.Card, { className: "mb-3" },
            react_1.default.createElement(react_bootstrap_1.Card.Header, { className: "d-flex align-items-center justify-content-between" },
                react_1.default.createElement("h5", { className: "mb-0" }, "P\u0142atno\u015B\u0107"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: handleCheckWhiteList, disabled: whiteListChecking }, whiteListChecking ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", className: "me-1" }),
                    "Weryfikacja...")) : ("Zweryfikuj rachunek (Biała lista)"))),
            react_1.default.createElement(react_bootstrap_1.Card.Body, null,
                whiteListError && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", className: "mb-3", onClose: () => setWhiteListError(null), dismissible: true }, whiteListError)),
                invoice.whiteListStatus === "VERIFIED_MISMATCH" && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", className: "mb-3" },
                    react_1.default.createElement("strong", null, "\u26A0\uFE0F Niezgodno\u015B\u0107 na Bia\u0142ej Li\u015Bcie VAT:"),
                    " numer rachunku dostawcy nie figuruje na Bia\u0142ej Li\u015Bcie na sprawdzan\u0105 dat\u0119. To ostrze\u017Cenie, nie blokada \u2014 ale zweryfikuj rachunek przed wykonaniem przelewu.")),
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.Col, { md: 12 },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Status p\u0142atno\u015Bci"),
                        react_1.default.createElement("div", { className: "mb-2" },
                            react_1.default.createElement(CostInvoicesBadges_1.PaymentMethodBadge, { paymentMethod: invoice.paymentMethod })),
                        react_1.default.createElement("div", { className: "d-flex gap-2 flex-wrap mb-2" }, [
                            { value: CostInvoicesController_1.PaymentStatuses.UNPAID, label: "● Niezapłacona" },
                            { value: CostInvoicesController_1.PaymentStatuses.PARTIALLY_PAID, label: "◑ Częściowo" },
                            { value: CostInvoicesController_1.PaymentStatuses.PAID, label: "✓ Zapłacona" },
                            { value: CostInvoicesController_1.PaymentStatuses.NOT_APPLICABLE, label: "– Nie dotyczy" },
                        ].map(({ value, label }) => (react_1.default.createElement(react_bootstrap_1.Button, { key: value, size: "sm", variant: paymentStatus === value ? "primary" : "outline-secondary", disabled: value === CostInvoicesController_1.PaymentStatuses.PARTIALLY_PAID && !canMarkPartiallyPaid, onClick: () => {
                                setPaymentStatus(value);
                                if (value === CostInvoicesController_1.PaymentStatuses.PAID)
                                    setPaidAmount(invoice.grossAmount);
                                if (value === CostInvoicesController_1.PaymentStatuses.UNPAID || value === CostInvoicesController_1.PaymentStatuses.NOT_APPLICABLE)
                                    setPaidAmount(0);
                            } }, label)))),
                        !canMarkPartiallyPaid && (react_1.default.createElement("div", { className: "text-muted small mb-2" }, "Dla dokument\u00F3w z ujemnym brutto status cz\u0119\u015Bciowej p\u0142atno\u015Bci nie jest dost\u0119pny.")),
                        paymentStatus === CostInvoicesController_1.PaymentStatuses.PARTIALLY_PAID && (react_1.default.createElement(react_bootstrap_1.Row, { className: "align-items-center g-2" },
                            react_1.default.createElement(react_bootstrap_1.Col, { xs: "auto" },
                                react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-0 small" }, "Kwota zap\u0142acona")),
                            react_1.default.createElement(react_bootstrap_1.Col, { xs: "auto" },
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "number", size: "sm", min: 0, max: invoice.grossAmount, step: 0.01, value: paidAmount, onChange: (e) => setPaidAmount(parseFloat(e.target.value) || 0), style: { width: "130px" } })),
                            react_1.default.createElement(react_bootstrap_1.Col, { xs: "auto" },
                                react_1.default.createElement("span", { className: "text-muted small" },
                                    "z ",
                                    Tools_1.default.formatNumber(invoice.grossAmount),
                                    " ",
                                    invoice.currency,
                                    " · ",
                                    "pozosta\u0142o:",
                                    " ",
                                    react_1.default.createElement("strong", { className: invoice.grossAmount - paidAmount > 0 ? "text-danger" : "text-success" },
                                        Tools_1.default.formatNumber(invoice.grossAmount - paidAmount),
                                        " ",
                                        invoice.currency))))))),
                react_1.default.createElement(react_bootstrap_1.Row, { className: "mt-3" },
                    react_1.default.createElement(react_bootstrap_1.Col, { md: 12 },
                        react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-0" },
                            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Notatki"),
                            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 2, value: notes, onChange: (e) => setNotes(e.target.value), placeholder: "Dodatkowe informacje..." })))))),
        react_1.default.createElement(react_bootstrap_1.Card, { className: "mb-3" },
            react_1.default.createElement(react_bootstrap_1.Card.Header, null,
                react_1.default.createElement("h5", { className: "mb-0" },
                    "Pozycje faktury (",
                    items.length,
                    ")")),
            react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "p-0" }, items.length === 0 ? (react_1.default.createElement("div", { className: "p-3 text-muted small" }, "Brak pozycji")) : (react_1.default.createElement(react_bootstrap_1.Table, { striped: true, hover: true, responsive: true, className: "mb-0" },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, "Lp."),
                        react_1.default.createElement("th", null, "Opis"),
                        react_1.default.createElement("th", { className: "text-end" }, "Ilo\u015B\u0107"),
                        react_1.default.createElement("th", { className: "text-end" }, "Cena jedn."),
                        react_1.default.createElement("th", { className: "text-end" }, "Netto"),
                        react_1.default.createElement("th", { className: "text-center" }, "VAT"),
                        react_1.default.createElement("th", { className: "text-end" }, "Brutto"))),
                react_1.default.createElement("tbody", null, items.map((item) => (react_1.default.createElement("tr", { key: item.id },
                    react_1.default.createElement("td", null, item.lineNumber),
                    react_1.default.createElement("td", null, item.description),
                    react_1.default.createElement("td", { className: "text-end" },
                        item.quantity,
                        " ",
                        item.unit),
                    react_1.default.createElement("td", { className: "text-end" }, Tools_1.default.formatNumber(item.unitPrice)),
                    react_1.default.createElement("td", { className: "text-end" }, Tools_1.default.formatNumber(item.netValue)),
                    react_1.default.createElement("td", { className: "text-center" },
                        item.vatRate,
                        "%"),
                    react_1.default.createElement("td", { className: "text-end" }, Tools_1.default.formatNumber(item.grossValue)))))))))),
        react_1.default.createElement("div", { className: "d-flex gap-2" },
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: handleSave, disabled: saving }, saving ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", className: "me-1" }),
                "Zapisywanie...")) : ("💾 Zapisz zmiany")))));
}
